import * as React from "react";

const SaHeaderIcon: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 12"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="#AF5D1B"
                fillRule="evenodd"
                d="M19.467 9.616l.312-.895-1.2-.504-.348-.378-1.142-1.23-.492-4.392-.374-.124-.116.09-.154 2.126-.215.019-.251-.17-.019-.166-.215-.184-.166.064-.055-.055L14.75.846l-.097-.102-3.376-.477-.14-.18L10.77 0 9.54.525l-.427 5.863-2.281.967-.036.216-.293.208H6.4l-1.12.614v.117l-1.012.48-.545.814S1.08 10.903 0 11.636c3.102-.745 6.4-1.225 10.978-1.296h2.35c2.169.034 4.235.16 6.142.363a1.219 1.219 0 01-.109-.516c0-.179.035-.371.106-.57"
            />
        </svg>
    );
};

export default React.memo(SaHeaderIcon);
